// Todo when we build the new PPP layout: Adapt this component and move it to shared components
import React from 'react'

export const OrganisationInfo = ({ carrierName, city, country }: OrganisationInfoProps) => {
  return (
    <div>
      <span
        className="font-bold block"
        dangerouslySetInnerHTML={{
          __html: I18n.t('projects.show.organisation_info.subline_carrier_html', {
            carrier_name: carrierName || '?',
          }),
        }}
      />{' '}
      <span
        className="text-gray-500 block"
        dangerouslySetInnerHTML={{
          __html:
            city || country
              ? I18n.t('projects.show.organisation_info.subline_location', {
                  location: [city, country].filter(Boolean).join(', '),
                })
              : I18n.t('projects.show.organisation_info.fallback_location'),
        }}
      />
    </div>
  )
}
